// extracted by mini-css-extract-plugin
module.exports = {"payWithCreditCard":"shared-module__payWithCreditCard___3qCe1"};